import { render } from "./VoucherRedeemStatusModal.vue?vue&type=template&id=68dc1352&scoped=true"
import script from "./VoucherRedeemStatusModal.vue?vue&type=script&lang=js"
export * from "./VoucherRedeemStatusModal.vue?vue&type=script&lang=js"

import "./VoucherRedeemStatusModal.vue?vue&type=style&index=0&id=68dc1352&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dc1352"]])

export default __exports__